import { Component, OnInit } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { AlertService, ResourceService } from 'sce-core';
import { CoreServiceRegistry } from '../../../../core/core-service-registry';
import { DataTableConfig } from '../../../search/models/data-table-config';
import { Clause, Condition, SearchCriteria } from '../../../search/models/search-filter-model';
import { SearchParams } from '../../../search/models/search-params.model';
import { SearchStatus } from '../../../search/models/search-status.model';
import { DataTableEditorService } from '../../../search/results/data-table-editor.service';
import { SearchService } from '../../../search/search.service';
import { SharedServiceRegistry } from '../../../shared-service-registry';

@Component({
  selector: 'lfwms-door-add-booking-detail-popup',
  templateUrl: './door-add-booking-detail-popup.component.html',
  styleUrls: ['./door-add-booking-detail-popup.component.css']
})
export class DoorAddBookingDetailPopupComponent implements OnInit {

  public searchServiceObj: { [key: string]: SearchService } = {};
  public searchService: SearchService;
  public cOptions: any[] = [
    { key: 'populatebyldplan', value: 'Load Plan' },
    { key: 'populatebyshipref', value: 'Ship Reference' },
    { key: 'populatebyshipgid', value: 'Shipment GID' },
  ];
  public inBoundBookASNOptions: any[] = [
    { key: 'populatebyasn', value: 'ASN' }
  ];
  public displayMode = 'V';
  private facility;
  private dataEditor;
  public cellData;
  private eventSubject = new Subject<any>();
  public resourceService: ResourceService;

  constructor(
    private coreServiceRegistry: CoreServiceRegistry,
    private sharedServiceRegistry: SharedServiceRegistry,
    private alertService: AlertService) {
    this.resourceService = this.coreServiceRegistry.resourceService;
  }

  ngOnInit() {
    //Switch case in html is required because result-data-tablr will subcribe to an event.
    //If we use single result-data-table, it'll subscribe to the first searchService event only.
  }

  public initializeComponents(facility: string, dataEditor: DataTableEditorService) {
    this.facility = facility;
    this.dataEditor = dataEditor;
    this.cellData = {
      cName: 'loadingType',
      cOptions: this.cOptions
    };
    this.initializeSearchService();
  }

  private initializeSearchService() {
    if (!this.cellData.cVal) {
      this.cellData.cVal = this.cOptions[0].key;
    }
    this.searchService = this.createSearchService();
    this.searchService.clearSavedSearchConfig(); // Clear any old data
    this.searchService.fetchMetadata().subscribe((_: any) => {
      this.performSearch();
    });
  }
  public initializeComponents1(facility: string, dataEditor: DataTableEditorService) {
    this.facility = facility;
    this.dataEditor = dataEditor;
    this.cellData = {
      cName: 'loadingType',
      cOptions: this.inBoundBookASNOptions
    };
    this.initializeSearchService1();
  }

  private initializeSearchService1() {
    if (!this.cellData.cVal) {
      this.cellData.cVal = this.inBoundBookASNOptions[0].key;
    }
    this.searchService = this.createSearchService();
    this.searchService.clearSavedSearchConfig(); // Clear any old data
    this.searchService.fetchMetadata().subscribe((_: any) => {
      this.performSearch();
    });
  }
  private createSearchService(): SearchService {
    if (this.searchServiceObj[this.cellData.cVal]) {
      return this.searchServiceObj[this.cellData.cVal];
    }
    const searchParams = new SearchParams();
    searchParams.tableId = this.cellData.cVal;
    searchParams.isFullFetch = true;
    searchParams.alertService = this.alertService;
    searchParams.tableEditor = this.dataEditor;
    searchParams.dataTableConfig = new DataTableConfig();
    const searchStatus = new SearchStatus();
    const searchService = this.sharedServiceRegistry.createSearchService(searchParams, searchStatus);
    this.searchServiceObj[this.cellData.cVal] = searchService;
    return searchService;
  }

  public performSearch() {
    this.searchService.setSearchCriteria(this.createDefaultSearchCriteria());
    this.searchService.getPagedData().pageRows = [];
    this.searchService.searchStatus.hasResults = false;
    // [LFWM-2075] - every search - re-initializing columnWidth and minColumnWidth on table load to avoid shrunk columns
    this.searchService.searchParams.dataTableConfig.columnWidth = 220;
    this.searchService.searchParams.dataTableConfig.minColumnWidth = 220;
    this.searchService.performSearch();
  }

  protected createDefaultSearchCriteria() {
    const defaultSearchCriteria: SearchCriteria = new SearchCriteria();
    defaultSearchCriteria.conditions = [];
    defaultSearchCriteria.loadDefaultCriteria = false;
    const facilityCondition: Condition = this.createSearchCondition(1);
    facilityCondition.isReadOnly = true;
    facilityCondition.isMandatory = false;
    const facilityClause: Clause = new Clause();
    facilityClause.column = 'facility';
    facilityClause.value = this.facility;
    facilityClause.operation = '=';
    facilityCondition.clauses = [facilityClause];
    facilityCondition.operator = null;
    defaultSearchCriteria.conditions.push(facilityCondition);
    return defaultSearchCriteria;
  }

  protected createSearchCondition(id: any) {
    const searchCondition = new Condition();
    searchCondition.id = id;
    searchCondition.displayMode = 'VIEW';
    return searchCondition;
  }

  public valueChanged(value: any, event: any) {
    this.cellData.cValPrev = this.cellData.cVal;
    this.cellData.cVal = event.newVal;
    this.initializeSearchService();
  }

  add() {
    this.eventSubject.next({
      type: 'add',
      data: this.searchService.getAllRows().filter(row => row.isSelected)
    });
    this.cancel();
  }

  cancel() {
    this.sharedServiceRegistry.sceModalService.modalReference.hide();
  }

  public notifyEvent(value: any) {
    this.eventSubject.next(value);
  }

  public receiveEvent(): Observable<any> {
    return this.eventSubject.asObservable();
  }

  // method used to translate the labels
  public getLabel(key: any) {
    return this.resourceService.get(key);
  }

}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/lookup/dock-door-booking-popups/door-add-booking-detail-popup/door-add-booking-detail-popup.component.ts